import React from 'react';
import { Box } from '@mui/material';

/**
 * Shared Earth/globe icon so every language/translate entry point uses the same asset.
 *
 * @param {{ size?: number, alt?: string, sx?: object }} props
 */
export default function EarthIcon({ size = 24, alt = '', sx = {} }) {
  return (
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL || ''}/earth-icon.svg`}
      alt={alt}
      aria-hidden={alt ? undefined : 'true'}
      sx={{
        width: size,
        height: size,
        display: 'block',
        flexShrink: 0,
        borderRadius: '50%',
        objectFit: 'cover',
        ...sx
      }}
    />
  );
}
